module.exports = __webpack_public_path__ + "img/dsci0090.7736b27e.jpg";